import styled from "styled-components";

export const Div = styled.div`
  display: inline-flex;
  gap: 0.6rem;
`;
